module.exports = __webpack_public_path__ + "static/media/tree-palm.238be32d.svg";